<!-- masquer sur mobile quand le menu s'ouvre -->
<wiz-header
  *ngIf="(showInterserviceHeader$ | async) === true"
  class="wiz-header"
  current="finance"
  [app]="applicationId"
  cookieKey="wizbii_tokens"
  [apiDomain]="apiDomain"
></wiz-header>

<router-outlet></router-outlet>
